/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import './About.scss'

import Header from '../../components/Header'
import Footer from '../../components/footer'

import { get } from '../../services/https'

export default function index() {
  const id = localStorage.getItem('shopId')
  const [shop, setShop] = useState()

  useEffect(() => {
    get(`/api/front/shops/${id}`)
      .then(response => {
        setShop(response.data.data[0])
      })
  }, [id])

  return (
    <div id='profile'>
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className='scroll'>
        <div className='profileTitle'>درباره ما</div>
        <div className='profileCard'>
            <div className='date'>
              {shop ? shop.name : '-'}
            </div>
            <div className='item'>
              <span>توضیحات : </span>
              <span> {shop ? shop.description : '-'}</span>
            </div>
            <hr />
            <div className='item'>
              <span>تلفن : </span>
              <span>{shop ? shop.tell : '-'}</span>
            </div>
            <hr />
            <div className='item'>
              <span>آدرس ایمیل : </span>
              <span>{shop ? shop.email : '-'}</span>
            </div>
            <hr />
            <div className='item'>
              <span>درباره :</span>
              <span>{shop ? shop.about : '-'}</span>
            </div>
            <hr />
            <div className='item'>
              <span>آدرس :</span>
              <span className=''>{shop ? shop.address : '-'}</span>
            </div>
            <hr />
            <div className='item address'>
              <span>ساعات کاری مجموعه :</span>
              {shop ? JSON.parse(shop.times).map(time => (
                <>
                  <span className='time'>{time.day}</span>
                  <span className='time'>{time.time}</span>
                </>
              )) : '-'}
            </div>
          </div>
      </div>
      <Footer page={''} />
    </div>
  )
}
